/**
 * Eine Seite, die es noch nicht gibt.
 *
 * Bewusst nicht "leer", sondern beschriftet: Wer im Schattenbetrieb durch die
 * Leiste klickt, soll lesen koennen, was hier einmal steht und welcher
 * Bauabschnitt es baut. Eine weisse Flaeche waere von einem Fehler nicht zu
 * unterscheiden — und genau der Zweifel kostet dann eine Rueckfrage.
 *
 * Verschwindet, sobald die letzte der acht Seiten gefuellt ist.
 */

import { Construction } from 'lucide-react';

interface PlatzhalterProps {
  titel: string;
  /** Was diese Seite einmal koennen wird — ein Satz, keine Aufzaehlung. */
  beschreibung: string;
  /** Der Bauabschnitt, der sie baut, z. B. "AP2". */
  abschnitt: string;
}

export function Platzhalter({ titel, beschreibung, abschnitt }: PlatzhalterProps) {
  return (
    <div>
      <h1 className="text-xl font-semibold text-slate-900">{titel}</h1>
      <p className="mt-1 text-sm text-slate-500">{beschreibung}</p>

      <div className="mt-6 flex items-start gap-3 rounded-xl border border-dashed border-slate-300 bg-white px-5 py-4">
        <Construction size={18} className="mt-0.5 shrink-0 text-slate-400" />
        <div className="text-sm text-slate-600">
          <p className="font-medium text-slate-800">Diese Seite wird gerade gebaut.</p>
          <p className="mt-0.5 text-slate-500">
            Sie gehört zu {abschnitt}. Bis dahin ist hier nichts zu tun.
          </p>
        </div>
      </div>
    </div>
  );
}
